exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agency__btnCreate___1yGWx {\n  flex: 0 0 auto;\n  height: 54px;\n  padding: 0 22px;\n  background-color: #8e8e8e;\n  color: #ffffff;\n  font-weight: 600; }\n\n.agency__form___1loVW {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 12px 16px;\n  border: 1px solid #e8e8e8;\n  width: 100%;\n  margin: -1px 0; }\n\n.agency__feedInput___2zrEL {\n  cursor: pointer;\n  font-family: monospace;\n  font-size: 11px; }\n\n.agency__feedStats___3jaYH {\n  white-space: nowrap;\n  margin: 12px 0; }\n\n.agency__actions___evyBq {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .agency__actions___evyBq > * + * {\n    margin-left: 6px; }\n", ""]);

// exports
exports.locals = {
	"btnCreate": "agency__btnCreate___1yGWx",
	"form": "agency__form___1loVW",
	"feedInput": "agency__feedInput___2zrEL",
	"feedStats": "agency__feedStats___3jaYH",
	"actions": "agency__actions___evyBq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageAgencyPage/styles/agency.scss
// module id = 4049
// module chunks = 6